const TERMS = [
  "LECTURA DEL PRECIO",
  "LIQUIDEZ",
  "ESTRUCTURA",
  "MANIPULACIÓN",
  "CONTEXTO INSTITUCIONAL",
  "GESTIÓN DEL RIESGO",
  "PSICOLOGÍA",
];

export const Marquee = () => {
  const items = [...TERMS, ...TERMS];
  return (
    <div
      data-testid="methodology-marquee"
      className="relative overflow-hidden border-y border-[#5EA2FF]/15 bg-[#030D20] py-7"
    >
      <div className="animate-marquee flex w-max items-center">
        {items.map((term, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span
              className={`px-10 font-display text-3xl font-bold uppercase tracking-tight sm:text-5xl ${
                i % 2 === 0 ? "text-white/90" : "text-stroke-faint"
              }`}
            >
              {term}
            </span>
            <span className="inline-block h-2 w-2 rotate-45 bg-[#2F7DF6]" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
};
